import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { BarChart3, BriefcaseBusiness, Building2, CalendarCheck, KanbanSquare, Menu, Plus, Search, X } from "lucide-react";
import { useState } from "react";
import { useCrm } from "@/context/CrmContext";
import { AddCompanyDialog } from "@/components/CrmDialogs";

const navItems = [
  { to: "/", label: "Kanban", icon: KanbanSquare, testId: "sidebar-kanban-link" },
  { to: "/dzisiaj", label: "Dzisiaj", icon: CalendarCheck, testId: "sidebar-today-link" },
  { to: "/firmy", label: "Firmy", icon: Building2, testId: "sidebar-companies-link" },
  { to: "/statystyki", label: "Statystyki", icon: BarChart3, testId: "sidebar-stats-link" },
];

export const AppShell = () => {
  const { persona, setPersona } = useCrm();
  const [mobileMenu, setMobileMenu] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const submitSearch = (event) => {
    event.preventDefault();
    if (search.trim()) navigate(`/firmy?q=${encodeURIComponent(search.trim())}`);
  };

  return (
    <div className="app-shell">
      <aside className={`sidebar ${mobileMenu ? "sidebar--open" : ""}`} aria-label="Główna nawigacja">
        <div className="brand-row">
          <div className="brand-mark" aria-hidden="true"><BriefcaseBusiness size={19} /></div>
          <div><strong>Mobipol</strong><span>Mini-CRM</span></div>
          <button className="icon-button sidebar-close" onClick={() => setMobileMenu(false)} data-testid="mobile-menu-close" aria-label="Zamknij menu"><X size={20} /></button>
        </div>
        <nav className="sidebar-nav">
          <p className="nav-eyebrow">Praca</p>
          {navItems.map(({ to, label, icon: Icon, testId }) => (
            <NavLink key={to} to={to} end={to === "/"} onClick={() => setMobileMenu(false)} data-testid={testId} className={({ isActive }) => `nav-link ${isActive ? "nav-link--active" : ""}`}>
              <Icon size={18} /><span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="sidebar-note"><span className="status-dot" />Dane zapisują się lokalnie</div>
          <p>Wireframe v1.0</p>
        </div>
      </aside>
      {mobileMenu && <button className="mobile-overlay" aria-label="Zamknij menu" onClick={() => setMobileMenu(false)} />}

      <div className="app-main">
        <header className="topbar">
          <button className="icon-button menu-button" onClick={() => setMobileMenu(true)} data-testid="mobile-menu-open" aria-label="Otwórz menu"><Menu size={20} /></button>
          <form className="global-search" onSubmit={submitSearch}>
            <Search size={17} aria-hidden="true" />
            <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Szukaj firmy…" aria-label="Szukaj firmy" data-testid="topbar-search-input" />
            <kbd>/</kbd>
          </form>
          <div className="topbar-actions">
            <label className="persona-control">
              <span>Tryb widoku</span>
              <select value={persona} onChange={(e) => setPersona(e.target.value)} data-testid="persona-switch" aria-label="Tryb widoku">
                <option value="sprzedaz">Piotr · Sprzedaż</option>
                <option value="wlasciciel">Właściciel · Wyniki</option>
                <option value="prezentacja">Tryb prezentacyjny</option>
              </select>
            </label>
            <button className="button button--primary top-add" onClick={() => setAddOpen(true)} data-testid="add-company-open-button"><Plus size={17} />Dodaj firmę</button>
          </div>
        </header>
        <main className={location.pathname === "/" ? "page page--wide" : "page"}><Outlet /></main>
      </div>

      <nav className="bottom-nav" aria-label="Nawigacja mobilna">
        {navItems.map(({ to, label, icon: Icon }) => <NavLink key={to} to={to} end={to === "/"} className={({ isActive }) => isActive ? "active" : ""}><Icon size={19} /><span>{label}</span></NavLink>)}
      </nav>
      <AddCompanyDialog open={addOpen} onOpenChange={setAddOpen} />
    </div>
  );
};
